import { render, staticRenderFns } from "./SignLawyer.vue?vue&type=template&id=3ab3715f&scoped=true"
import script from "./SignLawyer.vue?vue&type=script&lang=js"
export * from "./SignLawyer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab3715f",
  null
  
)

export default component.exports